import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Table from "react-bootstrap/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

const CohortTypeComponent = (props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedValue, setSelectedValue] = useState(props.cohortType || "");
  const cohortTypes = props.seedData.cohort_types || [];

  const filteredOptions = cohortTypes.filter((option) =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleRowClick = (option) => {
    setSelectedValue(option.id);
    props.handleCohortTypeChange(option.id);
  };

  useEffect(() => {
    setSelectedValue(props.cohortType);
  }, [props.cohortType]);

  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        <Box sx={{ width: "100%" }}>
          <FormControl component="fieldset" sx={{ width: "100%" }}>
            <p style={styles.label}>
              Cohort Type <span style={{ color: "red" }}>*</span>
            </p>
            <TextField
              fullWidth
              id="search-cohort"
              label="Select an option"
              variant="standard"
              value={searchTerm}
              onChange={handleSearchChange}
              sx={{
                "& .MuiInput-underline:before": {
                  borderBottomColor: "#14AE78",
                },
                "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
              }}
            />

            {/* SCROLLABLE TABLE START */}
            <div style={styles.scrollWrapper}>
              <TableContainer component={Paper} style={styles.tableContainer}>
                <Table style={styles.table} stickyHeader>
                  <TableBody>
                    {filteredOptions.map((option, index) => (
                      <TableRow
                        key={option.id}
                        hover
                        onClick={() => handleRowClick(option)}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#fff" : "#f0f0f0",
                          cursor: "pointer",
                        }}
                      >
                        <TableCell>
                          <FormControlLabel
                            value={option.id}
                            control={
                              <Radio
                                style={styles.radio}
                                checked={selectedValue === option.id}
                              />
                            }
                            label=""
                          />
                        </TableCell>
                        <TableCell>{option.name}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            {/* SCROLLABLE TABLE END */}

            {props.errors?.cohortType && (
              <p style={styles.errorMessage}>{props.errors.cohortType}</p>
            )}
          </FormControl>
        </Box>
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#FFFFFF",
    padding: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "start",
    boxSizing: "border-box",
  },
  contentWrapper: {
  
    padding: "20px",
    borderRadius: "24px",
    // boxShadow: "0 0 10px rgba(0,0,0,0.05)",
  },
  label: {
    fontSize: "22px",
    fontWeight: 500,
    textAlign: "left",
    marginBottom: "10px",
  },
  scrollWrapper: {
    width: "100%",
    overflowX: "auto",
  },
  tableContainer: {
    width: "100%",
    maxHeight: "50vh",
    overflowX: "auto",
  },
  table: {
    minWidth: "600px", // forces horizontal scroll on mobile
  },
  radio: {
    color: "#14AE78",
  },
  errorMessage: {
    color: "red",
    fontSize: "14px",
    marginTop: "8px",
    textAlign: "left",
  },
};

export default CohortTypeComponent;
